export default __webpack_public_path__ + "static/media/user-icon.9de4c2cd.svg";